module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile"
  }, [_c('button', {
    staticClass: "inner",
    class: _vm.tileClass,
    on: {
      "click": function($event) {
        _vm.$emit('hitClick', _vm.tile)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.tile.health) + "\n    "), _c('div', {
    staticClass: "multiplier",
    class: {
      'show': _vm.tile.multiplier > 1
    }
  }, [_vm._v("+" + _vm._s(_vm.tile.multiplier))]), _vm._v(" "), _c('div', {
    staticClass: "multiplier power-up-icon",
    class: {
      'show': _vm.tile.multiplier === -1
    }
  }, [_c('i', {
    staticClass: "fas fa-dice"
  })]), _vm._v(" "), _c('div', {
    staticClass: "multiplier-bonus",
    class: {
      'show': _vm.tile.health <= 0
    }
  }, [_vm._v(_vm._s(_vm.tile.bonusPoint))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2504a413","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tile.vue
// module id = 108
// module chunks = 1